import { useQuery } from '@tanstack/react-query';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { type MaintenanceStatusDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { setMaintenanceActive } from '@/contexts/maintenance/Maintenance.context.ts';

const REFRESH_MS = 60 * 1000;

export const useMaintenanceStatus = (): MaintenanceStatusDto | undefined => {
  const { maintenanceApi } = useApiClient();

  const { data } = useQuery<MaintenanceStatusDto>({
    queryFn: async () => {
      const { data } = await maintenanceApi.getMaintenanceStatus();
      if (data.active && !data.canWork) {
        setMaintenanceActive({
          maintenanceEnd: data.endDate ?? undefined,
          maintenanceMessage: data.message ?? undefined,
        });
      }
      return data;
    },
    queryKey: [QueryKeyEnum.MAINTENANCE.STATUS],
    refetchInterval: REFRESH_MS,
  });

  return data;
};
